import * as React from 'react';
import { isEqual, debounce, cloneDeep } from 'lodash';
import { change } from 'redux-form';

import KeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import Clear from 'material-ui/svg-icons/content/clear';

import { FormRemoteAutoComplete } from '@inqool/uas-web-core/es/components/controls/AutoCompleteRemote';

const defaultArrowStyle = (withLabel: boolean): React.CSSProperties => ({
  position: 'absolute',
  right: 0,
  top: withLabel ? 36 : 15
});

const defaultClearStyle = (withLabel: boolean): React.CSSProperties => ({
  position: 'absolute',
  right: 24,
  top: withLabel ? 36 : 15,
  cursor: 'pointer'
});

const showAllFilter = _ => {
  return true;
};

const getFilterByOperation = operation =>
  operation === 'STARTWITH'
    ? (text, key) => {
        const nText = text.toLocaleLowerCase();
        const nKey = key.toLocaleLowerCase();

        return nKey.startsWith(nText);
      }
    : (text, key) => {
        const nText = text.toLocaleLowerCase();
        const nKey = key.toLocaleLowerCase();

        return nKey.indexOf(nText) !== -1; // CONTAINS
      };

class RemoteAutoCompleteView extends React.Component<any, any, any> {
  state = {
    open: false,
    filterType: '',
    text: ''
  };
  node: any = null;
  handleSearchText = debounce(text => {
    const { lazy } = this.props;
    if (lazy) {
      this.setState({ text });
    }
  }, 700);

  removeFilter = () => {
    if (this.state.filterType === 'all') {
      this.setState({ filterType: '', open: false });
    }
  };

  openAutocomplete = () => {
    if (this.props.disabled) {
      return;
    }
    if (!this.state.open && this.node) {
      this.node.focus();
    }
    this.setState(state => ({ open: !state.open, filterType: 'all' }));
  };

  onBlur = () => {
    if (this.props.input.onBlur) {
      this.props.input.onBlur();
    }
    this.setState({ open: false, filterType: '' });
  };

  callback = (oldAutocompleteProps, newAutocompleteProps) => {
    const { dataSource: oldDataSource, onChange } = oldAutocompleteProps;
    const { dataSource, compareFn, value, setSearchText } = newAutocompleteProps;
    const { text } = this.state;

    if (!isEqual(oldDataSource, dataSource)) {
      const found = dataSource.find(item => compareFn(item.value, value));
      if (found && found.value) {
        onChange(found.value);
      } else if (this.props.lazy) {
        setSearchText(text);
      }
    }
  };

  myRef = node => {
    this.node = node;
  };

  getParams = suppliedParams => {
    const { lazy, labelFunction, input, operation } = this.props;
    const { text } = this.state;

    const labelValue = labelFunction(input.value);
    const params = suppliedParams ? cloneDeep(suppliedParams) : {};
    if (lazy) {
      params.pageSize = 10;
      if (text || labelValue) {
        params.filter = params.filter ? params.filter : [];
        params.filter.push({
          field: 'name',
          operation: operation ? operation : 'CONTAINS',
          value: text || labelValue
        });
      }
    }
    return params;
  };

  handleUpdateInputChange = text => {
    this.removeFilter();
    this.handleSearchText(text);
  };

  render() {
    const { lazy, params, operation, staticContext, ...props } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        <FormRemoteAutoComplete
          open={this.state.open}
          filter={this.state.filterType === 'all' ? showAllFilter : getFilterByOperation(operation)}
          onUpdateInputChange={this.handleUpdateInputChange}
          inputRef={this.myRef}
          onBlur={this.onBlur}
          callback={this.callback}
          params={this.getParams(params)}
          fullWidth={true}
          floatingLabelText={props.label}
          {...props}
        />
        <KeyboardArrowDown
          style={{
            ...(props.arrowstyle || defaultArrowStyle(!!props.label)),
            color: this.props.muiTheme.palette.disabledColor
          }}
          onClick={this.openAutocomplete}
        />
        {props.input.value &&
          !props.disabled && (
            <Clear
              onClick={() => props.meta.dispatch(change(props.meta.form, props.input.name, null))}
              style={{ ...defaultClearStyle(!!props.label), color: this.props.muiTheme.palette.disabledColor }}
            />
          )}
      </div>
    );
  }
}

export default RemoteAutoCompleteView;



// WEBPACK FOOTER //
// ./src/components/form/RemoteAutoComplete/RemoteAutocompleteView.tsx